export default __webpack_public_path__ + "static/media/charDollar.9e3134c8.svg";